import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { concat, from, of, Subscription, Observable, Subject } from 'rxjs';
import { map, switchMap, concatMap, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { Product, ProductInfo } from 'src/app/shared/product'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';

interface ProductSoldInfo extends Product {

  PRODCUSTOMER?: string;
  DOCNUMBER?: string;

}

@Component({
  selector: 'app-product-part-list-by-doc',
  templateUrl: './product-part-list-by-doc.component.html',
  styleUrls: ['./product-part-list-by-doc.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductPartListByDocComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  rows: number = 20;
  totalRecords: number;
  loading: boolean = false;

  filterPRODCODE: string;
  filterPRODNAME: string;
  filterPRODVENDORNAME: string;
  filterPRODCUSTOMER: string;
  filterPRODDOCUMENT: string;
  filterPRODSTOCK: number;
  filterPRODSOLD: number;
  filterPRODRESERV: number;
  filterPRODONHAND: number;

  monthToLoad: number = 6;

  productList: ProductSoldInfo[];

  @ViewChild('prodTable') prodTable: Table;

  selectedProduct: Product;     // single Selection mode

  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;

  private listOptions$ = new Subject<Date>();

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductPartListByDocComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductPartListByDocComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductPartListByDocComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProductPartListByDocComponent in ngOnDestroy')

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodRowQuery) { this._prodRowQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** ProductPartListByDocComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this._productQuery =
      this.listOptions$.pipe(
        switchMap(date => this.prodApi.getSoldProductPartsByDoc(date).pipe(map(products => {

          this.loading = false;

          this.totalRecords = products.length;
          this.productList = products;

          return products;
        }))),

        concatMap(products => from(products)),

        concatMap(prod => this.prodApi.getProdInfoById(
          prod.PRODID,
          this.globalSettinsData.mainCompanyId,
          this.globalSettinsData.balanceCurrencyId,
          this.globalSettinsData.mainStockId,
          this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
          this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
          new Date()
        )),

        concatMap(prodInfo => {
          console.log('*** ProductPartListByDocComponent getProdInfoById: ' + JSON.stringify(prodInfo));

          if (prodInfo.length > 0) {

            this.productList.filter(p => p.PRODID == prodInfo[0].PRODID).forEach(p => {
              p.PRODSTOCK = prodInfo[0].PRODSTOCK;
              p.PRODONHAND = prodInfo[0].PRODONWAY;
              p.PRODRESERV = prodInfo[0].PRODRESERVE;
            });

          //  let pri: number = this.productList.findIndex(p => p.PRODID == prodInfo[0].PRODID);

          //  if (pri >= 0) {

          //    this.productList[pri].PRODSTOCK = prodInfo[0].PRODSTOCK;
          //    this.productList[pri].PRODONHAND = prodInfo[0].PRODONWAY;
          //    this.productList[pri].PRODRESERV = prodInfo[0].PRODRESERVE;
          //  }
          }
          return of(prodInfo);
        }),

        finalize(() => {
          this.loading = false;
        })
      )
        .subscribe();

    let md: Date = new Date();
    md.setMonth(md.getMonth() - this.monthToLoad);
    this.listOptions$.next(md);

  }

  clearOrResetTableFilter(event) {
    console.log('*** ProductPartListByDocComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.monthToLoad = 6;

    this.selectedProduct = null;
    this.filterPRODCODE =
      this.filterPRODNAME =
      this.filterPRODCUSTOMER =
      this.filterPRODDOCUMENT =
      this.filterPRODVENDORNAME = '';

    this.filterPRODSTOCK =
      this.filterPRODSOLD =
      this.filterPRODRESERV =
      this.filterPRODONHAND = null;

    this.prodTable.clearState();
    this.prodTable.clear();

    let md: Date = new Date();
    md.setMonth(md.getMonth() - this.monthToLoad);
    this.listOptions$.next(md);
  }

  onSlideEnd(event) {
    console.log('*** ProductPartListByDocComponent onSlideEnd: ' + event.value)
    let md: Date = new Date();
    md.setMonth(md.getMonth() - this.monthToLoad);
    this.listOptions$.next(md);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** EditDocumentContentComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.productList);

      const exportData: any =
        this.productList.map(e => ({

          'Код товара': e.PRODCODE,
          'Название': e.PRODNAME,
          'Поставщик': e.PRODVENDORNAME,
          'Покупатель': e.PRODCUSTOMER,
          'Документ': e.DOCNUMBER,
          'Склад': e.PRODSTOCK,
          'Продано': e.PRODSOLD,
          'В резерве': e.PRODRESERV,
          'В транзите': e.PRODONHAND,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ['products'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }
}

